import { useEffect } from 'react';
import { useForm, FieldValues } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { addressSchema } from '@shared/lib/validators/registration-schema';
import { InputField } from '../../../shared/ui/input-field';
import { Button } from '../../../shared/ui/button';
import { RegisterHeader } from './RegistrationStepCompanyData';
import {
  addDeliveryAddress,
  selectLegalEntitiesPhysicalAddress,
  selectLegalEntityLegalAddress,
} from '../../../entities/registration/model';
import { useAppDispatch, useAppSelector } from '../../../app/store/store';

export const RegistrationStepDeliveryAddress = () => {
  const physicalAddress = useAppSelector(selectLegalEntitiesPhysicalAddress);
  const legalAddress = useSelector(selectLegalEntityLegalAddress);
  const dispatch = useAppDispatch();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(addressSchema),
    shouldUnregister: false,
  });

  const onSubmit = (data: FieldValues) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(addDeliveryAddress(data as any));
  };

  useEffect(() => {
    reset(physicalAddress);
  }, [physicalAddress, reset]);

  const onDoesItMatch = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    for (let key in legalAddress) {
      setValue(
        key as 'country' | 'region' | 'city' | 'street' | 'house' | 'apartment' | 'postcode',
        legalAddress[key]
      );
    }
  };

  return (
    <>
      <RegisterHeader isBack={true} stepSize={2} step={3} title="Адрес доставки" />
      {/* flex-col: отступы полей не схлопываются, расстояние между всеми
          полями одинаковое (90px от подписи до подписи, как в макете) —
          раньше у ряда «Дом/Офис» было 90, у остальных 74. */}
      <form className="w-full flex flex-col" onSubmit={handleSubmit(onSubmit)}>
        <InputField id="country" inputName="country" label="Страна доставки" placeholder="Введите страну" errors={errors} register={register} />
        <InputField id="region" inputName="region" label="Регион доставки" placeholder="Введите регион" errors={errors} register={register} />
        <InputField id="city" inputName="city" label="Город доставки" placeholder="Введите город" type="text" errors={errors} register={register} />
        <InputField id="street" inputName="street" label="Улица доставки" placeholder="Введите улицу" type="text" errors={errors} register={register} />
        <div className="flex w-full justify-between items-center gap-5 [&>div]:flex-1">
          <InputField id="house" inputName="house" label="Дом доставки" placeholder="Номер дома" type="text" errors={errors} register={register} />
          <InputField id="apartment" inputName="apartment" label="Офис доставки" placeholder="Номер офиса" type="text" errors={errors} register={register} />
        </div>
        <InputField id="postcode" inputName="postcode" label="Почтовый индекс доставки" placeholder="Введите индекс" type="text" errors={errors} register={register} />
        <div className="flex justify-between gap-5 mt-4">
          <Button isWhite={true} onClick={onDoesItMatch}>
            Совпадает с юр. адресом
          </Button>
          <Button type="submit" className="!w-[189px] shrink-0">Продолжить</Button>
        </div>
      </form>
    </>
  );
};
